import { render, staticRenderFns } from "./Input_Phone.vue?vue&type=template&id=04b550ea"
import script from "./Input_Phone.vue?vue&type=script&lang=js"
export * from "./Input_Phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports